// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Actions imports
import { setPage } from "../../actions";
// Components imports
import { ReactComponent as EthereumSvg } from '../../svg-icons/ethereum-color.svg';
import { ReactComponent as CpuChargeSvg } from '../../svg-icons/cpu-charge.svg';
import { ReactComponent as BinanceSmartChainSvg } from '../../svg-icons/blockchains/binance-smart-chain.svg';
// Hooks imports
import { useTelegram } from "../../hooks/useTelegram";
// Styles imports
import './Header.css';
import '../../util.css'
// Consts imports
import {
    PAGE_USER_AREA,
    ETH,
    BASE,
    BSC,
    PAGE_SELECT_BLOCKCHAIN
} from "../../consts/consts";

function Blockchain(props) {
    const { blockchain, handleSelectBlockchainClick } = props;
    if (blockchain === ETH) {
        return (
            <div className={"blockchain-block"} onClick={handleSelectBlockchainClick}>
                <span className={"blockchain-name"}>Ethereum</span>
                <EthereumSvg className={"blockchain-button-icon"}/>
            </div>
        )
    } else if (blockchain === BASE) {
        return (
            <div className={"blockchain-block"} onClick={handleSelectBlockchainClick}>
                <span className={"blockchain-name"}>Base</span>
                <img className={"blockchain-button-icon-img"}
                     src="./svg-icons/blockchains/base.png"/>
            </div>
        )
    } else if (blockchain === BSC) {
        return (
            <div className={"blockchain-block"} onClick={handleSelectBlockchainClick}>
                <span className={"blockchain-name"}>BSC</span>
                <BinanceSmartChainSvg className={"blockchain-button-icon"}/>
            </div>
        )
    } else {
        return (
            <div className={"blockchain-block"} onClick={handleSelectBlockchainClick}>
                <span className={"blockchain-name"}>Ethereum</span>
                <EthereumSvg className={"blockchain-button-icon"}/>
            </div>
        )
    }

}


class Header extends React.Component {

    handleSelectBlockchainClick = () => {
        const {setPage} = this.props;
        setPage(PAGE_SELECT_BLOCKCHAIN);
    };

    handleUserAreaClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_USER_AREA);
    };

    energyToString = (energy) => {
        let number = parseInt(energy, 10);  // Преобразуем строку в целое число
        if (number < 1000000) {
            // Форматируем число с пробелами для разделения тысяч
            return number.toLocaleString('en-US');  // Используем toLocaleString для разделителей
        } else {
            // Преобразуем число в формат M+ для чисел больше или равных 1 млн
            let million = number / 1000000;
            let formattedMillion = million.toFixed(1); // Форматируем до 1 знака после запятой
            return `${formattedMillion}M+`;
        }
    }

    render () {
        const { user } = useTelegram();
        const { ai_energy } = this.props.userData;
        const { page } = this.props.page;

        let username = user?.username;
        if (username == null) {
            username = user?.id.toString();
        }
        if (username == null) {
            username = 'no_name';
        }
        if (username.length > 10) {
            username = username.slice(0, 10)+'...';
        }

        if (page === PAGE_USER_AREA) {
            return null;
        } else {
            return(
                <div className={"header noselect"}>
                    <div className={"user-block"} onClick={this.handleUserAreaClick}>
                        <img
                            src={this.props.userData.photo_url}
                            className={"user-button-icon"}
                        />
                        <div className={"username-block"}>
                            <span className={"username"}>
                                {username}
                            </span>
                        </div>
                    </div>
                    <div className={"ai-resources-block"}>
                        <CpuChargeSvg className={"ai-resources-block_icon"}/>
                        <span className={"ai-resources-block_label"}>{this.energyToString(ai_energy)}</span>
                    </div>
                    <Blockchain blockchain={this.props.blockchain.blockchain} handleSelectBlockchainClick={this.handleSelectBlockchainClick}/>
                </div>
            );
        }
    }
}

const mapStateToProps = ({page, userData, blockchain}) => {
    return {page, userData, blockchain};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setPage: setPage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
